import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  text: 'Ho smesso di chiedermi cosa mangiare ogni sera. Mi sento più leggera e ho più energia — qualcosa che non succedeva da anni.',
  name: 'Giulia M.',
  age: '34 anni',
  city: 'Milano'
}, {
  text: "Non è una dieta. È un sistema che si adatta alla mia vita. La lista della spesa da sola vale l'intero acquisto.",
  name: 'Francesca R.',
  age: '41 anni',
  city: 'Napoli'
}, {
  text: 'Il gonfiore che avevo ogni sera è sparito in due settimane. Non ho eliminato nulla — ho solo imparato ad abbinare meglio gli alimenti.',
  name: 'Maria B.',
  age: '38 anni',
  city: 'Roma'
}, {
  text: 'Il Meal Prep mi ha cambiato la settimana. Lavoro dodici ore al giorno e finalmente ho un sistema che si adatta ai miei ritmi.',
  name: 'Marco E.',
  age: '45 anni',
  city: 'Torino'
}, {
  text: 'Il Reset 21 Giorni mi ha aiutato a costruire abitudini che mantengo ancora dopo quattro mesi. Premium senza dubbi.',
  name: 'Laura R.',
  age: '52 anni',
  city: 'Verona'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-16 px-4 bg-[#eef3ea]" data-id="element-300">
      <div className="max-w-3xl mx-auto" data-id="element-301">
        {/* Vision Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-16 max-w-xl mx-auto" data-id="element-302">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-olive mb-4 sm:mb-6" data-id="element-303">
            Immagina tra 30 giorni.
          </h2>
          <div className="space-y-2 text-sm sm:text-lg text-brand-text-main font-medium" data-id="element-304">
            <p data-id="element-305">Apri il frigorifero. Sai già cosa preparare.</p>
            <p data-id="element-306">Ti siedi a tavola e mangi con piacere.</p>
            <p data-id="element-307">Senza stress. Senza sensi di colpa.</p>
            <p data-id="element-308">Ti svegli leggero. Hai energia tutto il giorno.</p>
            <p className="text-base sm:text-xl font-bold text-brand-olive mt-3 sm:mt-4" data-id="element-309">
              E per la prima volta — non aspetti più lunedì.
            </p>
          </div>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-310">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white border border-brand-sage/20 p-5 sm:p-6 rounded-2xl shadow-sm" data-id="element-311">
              <div className="flex items-center gap-2 mb-3" data-id="element-312">
                <div className="flex text-brand-gold" data-id="element-313">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-314" />)}
                </div>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-brand-olive" data-id="element-315">
                  <BadgeCheckIcon className="w-4 h-4" data-id="element-316" /> Verificato
                </span>
              </div>
              <p className="text-brand-text-main font-medium italic mb-3 sm:mb-4 text-base sm:text-lg" data-id="element-317">
                "{t.text}"
              </p>
              <div className="border-t border-brand-sage/10 pt-3" data-id="element-318">
                <span className="text-xs sm:text-sm text-brand-text-muted font-bold" data-id="element-319">
                  {t.name} — {t.age} · 📍 {t.city}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}